export const fallbackLanguage = 'es';
export const languages = ['es'];
export const defaultNamespace = 'common';
export const preloadNamespaces = ['common', 'account', 'installation-location'];
